import Vue from 'vue'
import ToastComponent from './index.vue'

const ToastConstructor = Vue.extend(ToastComponent)

let instance = null
let seed = 1

const Toast = (options) => {
  if (Vue.prototype.$isServer) return
  
  // 如果已有实例，直接复用
  if (!instance) {
    instance = new ToastConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
  
  // 显示新消息
  instance.show(options)
  
  return instance
}

// 便捷方法
Toast.success = (message, duration = 2000) => {
  return Toast({
    message,
    type: 'success',
    duration
  })
}

Toast.error = (message, duration = 2000) => {
  return Toast({
    message,
    type: 'error',
    duration
  })
}

Toast.warning = (message, duration = 2000) => {
  return Toast({
    message,
    type: 'warning',
    duration
  })
}

Toast.info = (message, duration = 2000) => {
  return Toast({
    message,
    type: 'info',
    duration
  })
}

// 关闭方法
Toast.close = () => {
  if (instance) {
    instance.close()
  }
}

// Vue 插件安装方法
Toast.install = (Vue) => {
  Vue.prototype.$toast = Toast
}

export default Toast

